if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      //this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if(!document.querySelector(".ajax-cart-disabled")) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          //window.scrollTo({top: 0, behavior: 'smooth'});
          if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
          this.cartNotification.renderContents(response);
          openCartDrawer();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/* ===== USAGS mobile swipe gallery ============================================
   Adds native finger-swipe scrolling to the product-page image gallery on
   mobile. Progressive enhancement: reads the existing .ai-product-gallery
   thumbnails, builds a CSS scroll-snap track, shows it only under 750px, and
   leaves desktop untouched. Safe no-op on pages without the gallery.
   Slides are a fixed square so mixed image sizes don't leave gaps.
   =========================================================================== */
(function () {
  var MOBILE = '(max-width: 749px)';

  function injectStyles() {
    if (document.getElementById('usags-swipe-styles')) return;
    var css =
      '.usags-swipe-track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;width:100%;}' +
      '.usags-swipe-track::-webkit-scrollbar{display:none;}' +
      '.usags-swipe-slide{flex:0 0 100%;scroll-snap-align:center;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;background:#fff;}' +
      '.usags-swipe-slide img{width:100%;height:100%;object-fit:contain;display:block;}' +
      '.usags-swipe-dots{display:flex;justify-content:center;gap:6px;padding:10px 0 4px;}' +
      '.usags-swipe-dot{width:8px;height:8px;border-radius:50%;background:#ccc;transition:background .2s ease;}' +
      '.usags-swipe-dot.is-active{background:#47cbfb;}' +
      '@media (max-width:749px){.usags-swipe-on [data-main-image]{display:none!important;}.usags-swipe-on [data-zoom-overlay]{display:none!important;}}' +
      '@media (min-width:750px){.usags-swipe-track,.usags-swipe-dots{display:none!important;}}';
    var style = document.createElement('style');
    style.id = 'usags-swipe-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function enhance(main) {
    var wrapper = main.parentElement;
    if (!wrapper || wrapper.dataset.usagsSwipe) return;
    var container = wrapper.parentElement || wrapper;
    var thumbs = Array.prototype.slice.call(container.querySelectorAll('[data-thumbnail]'));

    var slides = thumbs.length
      ? thumbs.map(function (t) {
          return { url: t.getAttribute('data-image-url'), alt: t.getAttribute('data-image-alt') || '' };
        })
      : [{ url: main.getAttribute('src'), alt: main.getAttribute('alt') || '' }];

    if (slides.length < 2) return;
    wrapper.dataset.usagsSwipe = '1';

    var track = document.createElement('div');
    track.className = 'usags-swipe-track';
    slides.forEach(function (s) {
      var slide = document.createElement('div');
      slide.className = 'usags-swipe-slide';
      var img = document.createElement('img');
      img.src = s.url;
      img.alt = s.alt;
      img.setAttribute('loading', 'lazy');
      slide.appendChild(img);
      track.appendChild(slide);
    });

    var dots = document.createElement('div');
    dots.className = 'usags-swipe-dots';
    slides.forEach(function (_item, i) {
      var d = document.createElement('span');
      d.className = 'usags-swipe-dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    });
    var dotEls = Array.prototype.slice.call(dots.querySelectorAll('.usags-swipe-dot'));

    wrapper.appendChild(track);
    wrapper.appendChild(dots);
    wrapper.classList.add('usags-swipe-on');

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dotEls.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
      });
    }, { passive: true });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });
  }

  function run() {
    if (!window.matchMedia || !window.matchMedia(MOBILE).matches) return;
    injectStyles();
    Array.prototype.slice.call(document.querySelectorAll('[data-main-image]')).forEach(enhance);
  }

  function boot() {
    run();
    if (window.matchMedia) {
      var mq = window.matchMedia(MOBILE);
      if (mq.addEventListener) mq.addEventListener('change', run);
      else if (mq.addListener) mq.addListener(run);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* ===== USAGS combined wishlist + favorites ===================================
   Keeps the original Swym "Add to Wishlist" button exactly as-is (its own
   design/styling, untouched), hides the separate Klaviyo favorites button, and
   makes a click on the wishlist button ALSO trigger the Klaviyo favorites
   button. One button, original look, does both. Safe no-op if apps absent.
   =========================================================================== */
(function () {
  var SWYM_SEL = '.swym-wishlist-button-bar .swym-add-to-wishlist, .swym-wishlist-button-bar button.swym-button';

  function klBtn() {
    var m = document.querySelector('klaviyo-favorites-button');
    if (m) { var b = m.querySelector('button'); if (b) return b; }
    return document.querySelector('.kl-hub-favorites-widget');
  }

  document.addEventListener('click', function (e) {
    var swym = e.target && e.target.closest ? e.target.closest(SWYM_SEL) : null;
    if (!swym) return;
    var k = klBtn();
    if (k) setTimeout(function () { k.click(); }, 0);
  }, true);

  function hideKlaviyo() {
    var m = document.querySelector('klaviyo-favorites-button');
    if (m) m.style.display = 'none';
  }
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (document.querySelector('klaviyo-favorites-button') || tries > 40) {
      clearInterval(timer);
      hideKlaviyo();
    }
  }, 400);
})();
